import { INSTALLMENT_PAYMENT_MAX_AMOUNT_CENTS, INSTALLMENT_PAYMENT_MIN_AMOUNT_CENTS, } from '@massilia/contracts';
// La source de vérité des bornes du paiement fractionné est @massilia/contracts, en centimes :
// le serveur ne peut pas importer @massilia/features (il ne dépend que de @massilia/contracts et
// @massilia/prisma-generated). On se contente ici d'exposer les mêmes bornes en euros, unité
// attendue par les écrans qui manipulent des prix affichés.
export const INSTALLMENTS_MIN_AMOUNT = INSTALLMENT_PAYMENT_MIN_AMOUNT_CENTS / 100;
export const INSTALLMENTS_MAX_AMOUNT = INSTALLMENT_PAYMENT_MAX_AMOUNT_CENTS / 100;
